import { ChevronRightIcon, ICON_COLOR } from '@zep-us/zus';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
export const PhoneVerificationBanner = () => {
  const router = useRouter();
  const {
    t
  } = useTranslation(['common']);
  const handleClick = () => {
    logger.track('profile_phone_auth_click', {
      location: 'profile_edit'
    });
    void router.push({
      pathname: '/verification-phone',
      query: {
        from: 'profile_edit'
      }
    });
  };
  return <div className="flex h-[88px] w-full cursor-pointer items-center justify-between rounded-md bg-gradient-to-r from-blue-400 to-violet-400 px-md mobile-lg:h-[120px] mobile-lg:px-lg" onClick={handleClick} data-sentry-component="PhoneVerificationBanner" data-sentry-source-file="PhoneVerificationBanner.tsx">
      <div className="flex flex-col gap-[1px] text-inverse">
        <p className="text-body-md-bold mobile-lg:text-body-lg-bold">
          {t('phoneVerify.banner.description')}
        </p>
        <div className="item-center flex">
          <p className="text-body-lg-bold mobile-sm:text-heading-sm-bold mobile-lg:text-heading-lg-extrabold">
            {t('phoneVerify.banner.title')}
          </p>
          <ChevronRightIcon size="sm" fill={ICON_COLOR.inverse} className="mobile-lg:hidden" data-sentry-element="ChevronRightIcon" data-sentry-source-file="PhoneVerificationBanner.tsx" />
          <ChevronRightIcon size="lg" fill={ICON_COLOR.inverse} className="hidden mobile-lg:block" data-sentry-element="ChevronRightIcon" data-sentry-source-file="PhoneVerificationBanner.tsx" />
        </div>
      </div>
      <div className="flex h-full items-end">
        <img src="/assets/phone_verification_banner.webp" alt="phone-verification-banner" className="w-[108px] mobile-lg:w-[170px]" />
      </div>
    </div>;
};